import { Row } from 'antd';
import clsx from 'clsx';
import type React from 'react';
import { Link } from 'react-router';
import logoSmall from '@/assets/images/logo/hc_logo_1.svg';
import logo from '@/assets/images/logo/hc_logo_2.svg';
import Config from '@/configs/appConfig.jsx';
import themeConfig from '@/configs/themeConfig.jsx';
import { IS_LOCAL_ENV } from '@/const/features.js';
import styles from './Logo.module.css';

interface MenuLogoProps {
  small?: boolean;
  isMobile?: boolean;
  closeHandler: () => void;
}

const currentEnvLabel = (appEnv: 'local' | 'develop' | 'staging') => {
  const envMapping = {
    local: 'local',
    develop: 'dev',
    staging: 'qa',
  };

  return envMapping[appEnv] || '';
};

const MenuLogo: React.FC<MenuLogoProps> = ({ small = false, closeHandler, isMobile }) => {
  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.small]: small,
        [styles.mobile]: isMobile,
      })}
    >
      <Link to="../" onClick={closeHandler}>
        <img className={styles.logo} src={small ? logoSmall : logo} alt={small ? 'logo-sm' : 'logo-lg'} />
      </Link>

      <div className={styles.version}>
        v.
        {themeConfig.version}
      </div>

      <Row gutter={[0, 16]}>
        <div className={styles.appEnvLabel} style={small ? { marginLeft: 'unset' } : {}}>
          {currentEnvLabel(!IS_LOCAL_ENV ? Config.VITE_APP_ENVIRONMENT : 'local')}
        </div>
      </Row>
    </div>
  );
};

export default MenuLogo;
